export class Thresholds {
  public red: {};
  public yellow: {};
  constructor() {
    this.red = {
      "ABN": 0,
      "ASA": 0,
      "Queue": 0,
      "Oldest": 0
    };
    this.yellow = {
      "ABN": 0,
      "ASA": 0,
      "Queue": 0,
      "Oldest": 0
    };
  }
}
